export const CHECKOUT_URL = 'https://welding-instructor-atlas.impultienda.ar/checkout'

export const HERO_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/ce375233-897d-4539-a6cb-1fdc37e0b6d7/product-uploads/mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859544230.png'

export const HERO_IMAGE_ALT =
  'Welding Instructor Atlas 6-in-1 box set in charcoal, brushed steel and safety orange: 6 visual welding technology and technical training volumes for welding instructors, technical schools and training workshops'

export const VISUAL_IMAGE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/ce375233-897d-4539-a6cb-1fdc37e0b6d7/product-uploads/mcp_be0e6a9b-d609-47e7-80db-774208b012e5_1793859566753.jpg'

export const VISUAL_IMAGE_ALT =
  'Welding Instructor Atlas: the 6-volume box set next to a tablet with the welding teaching areas, 100% visual material for welding instructors and technical schools, with immediate access'

export const PRIMARY_CTA = 'GET WELDING INSTRUCTOR ATLAS NOW!'

export const PRICE_LABEL = '$27 USD'

export interface IncludedItem {
  label: string
  kind: 'included' | 'bonus' | 'extra'
}

export const packageIncludes: IncludedItem[] = [
  { kind: 'included', label: 'Volume 01 — Welding Fundamentals, Safety, Equipment & Metal Preparation' },
  { kind: 'included', label: 'Volume 02 — MIG/MAG Welding, GMAW Techniques & Practical Applications' },
  { kind: 'included', label: 'Volume 03 — TIG Welding, GTAW Techniques & Precision Fabrication' },
  { kind: 'included', label: 'Volume 04 — Stick Welding, SMAW Processes & Structural Welding' },
  { kind: 'included', label: 'Volume 05 — Welding Blueprints, Symbols, Inspection & Quality Control' },
  { kind: 'included', label: 'Volume 06 — Welding Instruction, Workshop Training & Practical Assessments' },
  { kind: 'bonus', label: 'Welding Machine Settings & Parameters Quick-Reference Charts' },
  { kind: 'bonus', label: 'Welding Demonstration Lesson Scripts' },
  { kind: 'bonus', label: 'Welding Practice Projects & Coupon Exercise Workbook' },
  { kind: 'bonus', label: 'Weld Defect Identification Flashcards' },
  { kind: 'bonus', label: 'Welding Competency Checklists, Rubrics & Certificates' },
  { kind: 'extra', label: '100% Visual Training System' },
  { kind: 'extra', label: 'Immediate Digital Access' },
  { kind: 'extra', label: 'One-Time Payment' },
]
